import * as React from 'react';

import { diagnostics } from 'ui-common';

import AppHeader from 'login-components/AppHeader/AppHeader';
import Masthead from 'login-components/Masthead/Masthead';

export interface ErrorBoundaryProps {
  children?: React.ReactNode;
}

export interface ErrorBoundaryState {
  error?: Error;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {};
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    diagnostics.breadcrumb(JSON.stringify(info, undefined, 2));
    diagnostics.error(error);

    this.setState({ error });
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    return error ? (
      <div>
        <Masthead />
        <AppHeader text="You have encountered an error. Please refresh the page." />
      </div>
    ) : (
      children
    );
  }
}
